import Vue from 'vue'

export default function login({ nickname, password }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/login"
    return Vue.http
        .post(url, { nickname, password }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch((err) => { throw err })
}